<div class="modal fade" id="assignModal" tabindex="-1">
  <div class="modal-dialog modal-xl">
    <div class="modal-content dirI">
      <div class="modal-header dirI">
        <h5 class="modal-title" id="exampleModalLabel">برنامه راننده</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body">
        <div class="col-12 section border border-2 mt-2" style="max-height: calc(100vh - 270px); overflow: auto">
          <table class="col-12 table table-striped rounded-3 assign-table" id="Export_Excel">
            <thead>
              <tr>
                <th class="text-center col-1">#</th>
                <th class="text-center col-1">تاریخ</th>
                <th class="text-center">ساعت</th>
                <th class="text-center">شهر مبداء</th>
                <th class="text-center">گروه</th>
                <th class="text-center">نام خودرو</th>
                <th class="text-center">نوع</th>
                <th class="text-center">مدل خودرو</th>
                <th class="text-center">نام راننده</th>
                <th class="text-center">موبایل</th>
                <th class="text-center">سفر&zwnj;ها</th>
                <th class="text-center">لغو&zwnj;ها</th>
              </tr>
            </thead>
            <tbody>
              <tr class="col-12 text-center" *ngFor="let item of trips; let i = index">
                <td>{{ i + 1 | faNum }}</td>
                <td>{{ item.strDate | faNum }}</td>
                <td>{{ item.strSTime | faNum }}</td>
                <td>{{ item.strCityName | faNum }}</td>
                <td>{{ item.strMobileGroup_strComment | faNum }}</td>
                <td>{{ item.strGPSType_strComment | faNum }}</td>
                <td>{{ item.strMobileType_strComment | faNum }}</td>
                <td>{{ item.iYearConstruction | faNum }}</td>
                <td>{{ item.strFullName | faNum }}</td>
                <td>{{ item.strMobile | faNum }}</td>
                <td>{{ item.iTrip | faNum }}</td>
                <td>{{ item.iCancel | faNum }}</td>
              </tr>
              <tr *ngIf="!trips?.length">
                <td colspan="12" class="assign-empty">برنامه‌ای برای این خودرو یافت نشد.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="modal-footer assign-footer">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal">بستن</button>
      </div>
    </div>
  </div>
</div>
